import { render } from "./DialogOptionsConfirm.vue?vue&type=template&id=6f145e59&ts=true"
import script from "./DialogOptionsConfirm.vue?vue&type=script&lang=ts"
export * from "./DialogOptionsConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__